import { Box } from "@mui/system";
import { ReactNode, useCallback } from "react";
import { ErrorBoundary, useUserContext } from "@WahooFitness/wahoo-offline-mfe";
import { UserType } from "@WahooFitness/cloud-client-types";
import { Container } from "@mui/material";

function QuizContainer({ renderQuiz }: { renderQuiz: (user: UserType) => ReactNode }) {
  const { currentUser, userIsLoading, userError, mutateUser } = useUserContext();
  const handleReload = useCallback(() => {
    mutateUser();
  }, [mutateUser]);

  return (
    // wf-self-scrolling-page suppresses the shell's page-end spacer: this page fills
    // the scrollport and handles its own bottom clearance via the sticky action bar,
    // so the spacer would only add empty scrollable space below it.
    <Container
      className="wf-self-scrolling-page"
      maxWidth="sm"
      disableGutters
      sx={{ minHeight: "100%", display: "flex", flexDirection: "column" }}
    >
      <ErrorBoundary error={userError} isLoading={userIsLoading} onReload={handleReload}>
        <Box display="flex" flexDirection="column" width="100%" flexGrow={1}>
          {currentUser && renderQuiz(currentUser)}
        </Box>
      </ErrorBoundary>
    </Container>
  );
}

export default QuizContainer;
